import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { Input, Button, Form } from 'antd';

import {signIn} from './actions';

class SignIn extends Component {
  constructor(props) {
    super(props);
    this.state = {
        username: '',
        password: '',
    }
  }

  onUsernameUpdate(e){
    this.setState({
        username: e.target.value,
    });
  }
  onPasswordUpdate(e){
    this.setState({
        password: e.target.value,
    });
  }

  onSignIn(){
    this.props.signIn(this.state.username, this.state.password);
  }

  render() {
    return(
        <div>
            <h2>Sign In</h2>
            <Form>
                <Form.Item label="Username" style={{ marginBottom: 10, marginTop: 5 }}>
                    <Input value={this.state.username} id="username" 
                        onChange={this.onUsernameUpdate.bind(this)} />
                </Form.Item>
                <Form.Item label="Password" style={{ marginBottom: 10, marginTop: 5 }}>
                    <Input value={this.state.password} id="password" 
                        onChange={this.onPasswordUpdate.bind(this)} type="password" />
                </Form.Item>
                <Button type="primary" onClick={this.onSignIn.bind(this)} z>Sign In</Button>
            </Form>
        </div>
    )
    }
}

// Map props to the store

SignIn.propTypes = {
    signIn: PropTypes.func,
}

const mapStateToProps = () => ({
});

const mapDispatchToProps = (dispatch) => ({
    signIn: (username, password)=>{
        dispatch(signIn({
            username,
            password, 
        }));
    },
});

const SignInContainer = connect(mapStateToProps,mapDispatchToProps)(SignIn);

export default SignInContainer;


// WEBPACK FOOTER //
// ./src/auth/SignIn.jsx